export enum EAudioRecordingType {
  FULL = 'full',
  SEGMENT = 'segment',
}
